/**
 * The registered portal-root names Copilot chat overlays render into.
 *
 * The names are separated from the containers that register them so surfaces
 * below Copilot chat — the composer's pickers, for one — can target the same
 * root without importing the containers or the chat tree they live in.
 */
export const COPILOT_CHAT_MENU_PORTAL_ROOT = 'copilotChatMenuPortalRoot'
export const COPILOT_CHAT_MESSAGES_MENU_PORTAL_ROOT = 'copilotChatMessagesMenuPortalRoot'
export const COPILOT_CHAT_PORTAL_ROOT = 'copilotChatPortalRoot'
export const COPILOT_CHAT_TOPIC_PICKER_PORTAL_ROOT = 'copilotChatTopicPickerPortalRoot'
